import { t } from "i18next";
import React, { useEffect, useState } from "react";
import DevicesTable from "./table/DevicesTable";
import { Button, Text } from "@radix-ui/themes";
import AddDevice from "./AddDevice";
import { useFetch } from "../../../../hooks/useFetch";
import { Sensor } from "../../../../types/types";
import _ from "lodash";

type Props = {
  id: string;
};

const DevicesTab = ({ id }: Props) => {
  const [sensors, setSensors] = useState<Sensor[]>();

  const [{ response, isLoading, error }, doFetchSensors] = useFetch(
    `/directories/equipment_items/${id}/sensors`
  );

  useEffect(() => {
    doFetchSensors();
  }, []);

  useEffect(() => {
    setSensors(response?.data as unknown as Sensor[]);
  }, [response]);

  let nodes = sensors?.map((sensors) => {
    return {
      id: sensors.id,
      date: sensors.attributes.equipment_item_connected_at,
      device_serial_number: sensors.attributes.device_serial_number,
      factor: sensors.attributes.factor,
      slot_name: sensors.attributes.slot_name,
      sensor_type_name: sensors.attributes.sensor_type.name,
      idle_level: sensors.attributes.idle_level,
      turned_off_level: sensors.attributes.turned_off_level,
      online: sensors.attributes.online,
    };
  });

  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  return (
    <div className="relative flex flex-col max-w-[1008px] h-full overflow-hidden bg-background">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          <span className="text-2xl font-semibold">{t('connect_device_to_equipment')}</span>
        </div>
      </div>
      <div className="pt-2 flex flex-col w-full gap-8 px-6">
        <AddDevice equipmentId={id} updateList={doFetchSensors} />
        {sensors ? <DevicesTable data={data} equipmentId={id} updateList={doFetchSensors} /> : ""}
      </div>
    </div>
  );
};

export default DevicesTab;
